import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"

const AdminExtranjerosHaitianosComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()
  return (
    <CRUD

      isModal={false}
      additionalButtons={<>
        <button className="btn btn-primary btn-sm me-2" onClick={() => props.toggle("addEdit")}>
          <i className="fas fa-plus"></i> {t("Importar Extranjeros")}
        </button>
      </>}
      cssClass="modalRight"
      recordButtonsPosition="start"
      showModal={props.show}
      toggleCRUD={props.toggle}
      filterOpen={true}
      title={t("Extranjeros") ?? ""}
      icon={"fas fa-users"}
      getRecordsPath={`extranjeros/busqueda/`}
      addEditRecordPath={`extranjeros/AddEdit?currentUserId=${user.ID}`}
      deleteRecordPath="extranjeros/delete"
      filterFields={[
        {
          name: "nombres",
          htmlType: "text",
          dbType: "string",
          title: "Nombres",
          containerClass: "col-12 col-md-4",
          required: false,
        },
        {
          name: "apellidos",
          htmlType: "text",
          dbType: "string",
          title: "Apellidos",
          containerClass: "col-12 col-md-4",
          required: false,
        },

        {
          name: "alias",
          htmlType: "text",
          dbType: "string",
          title: "Alias",
          containerClass: "col-12 col-md-4",
          required: false,
        },

        {
          name: "cedula",
          htmlType: "text",
          dbType: "string",
          title: "cedula",
          containerClass: "col-12 col-md-4",
          required: false,
        },
        {
          name: "passport",
          htmlType: "text",
          dbType: "string",
          title: "Passport",
          containerClass: "col-12 col-md-4",
          required: false,
        },
        {
          name: "withPicture",
          htmlType: "select",
          dbType: "boolean",
          title: "CF",
          containerClass: "col-12 col-md-4",
          required: false,
          dataSourceLocal: [
            { name: "Si", id: "true" },
            { name: "No", id: "false" },
          ],
          dataSourceTextField: "name",
          dataSourceValueField: "id",
          value: "true",
        }
      ]}
      fieldsList={[
        {
          name: "idFotoFrente",
          title: t("Foto"),
          htmlType: "imageExtranjeros",
          cssClass: "",
        },
        {
          name: "nombres",
          title: t("Nombres"),
        },
        {
          name: "primerApellido",
          title: t("Primer Apellido"),
        },
        {
          name: "segundoApellido",
          title: t("Segundo Apellido"),
        },
        {
          name: "cedula",
          title: t("Cédula"),
        },
        {
          name: "pasaporte",
          title: t("Pasaporte"),
        },
        {
          name: "fechaNacimiento",
          title: t("Fecha de Nacimiento"),
        },
        {
          name: "alias1",
          title: t("Alias 1"),
        },
        {
          name: "alias2",
          title: t("Alias 2"),
        },
        {
          name: "alias3",
          title: t("Alias 3"),
        },
        {
          name: "nacionalidad",
          title: t("Nacionalidad"),
        },
        {
          name: "violacion",
          title: t("Violación"),
        },
      ]}
      fields={[
        { name: "id", htmlType: "hidden", dbType: "string" },
        { name: "no", required: true, htmlType: "text", dbType: "string", title: t("No") ?? "", containerClass: "col-12 col-md-6" },
        { name: "nombres", htmlType: "text", dbType: "string", title: t("Nombres") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "primerApellido", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "segundoApellido", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "alias1", htmlType: "text", dbType: "string", title: t("Alias 1") ?? "", containerClass: "col-12 col-md-6" },
        { name: "alias2", htmlType: "text", dbType: "string", title: t("Alias 2") ?? "", containerClass: "col-12 col-md-6" },
        { name: "alias3", htmlType: "text", dbType: "string", title: t("Alias 3") ?? "", containerClass: "col-12 col-md-6" },
        { name: "alias4", htmlType: "text", dbType: "string", title: t("Alias 4") ?? "", containerClass: "col-12 col-md-6" },
        { name: "alias5", htmlType: "text", dbType: "string", title: t("Alias 5") ?? "", containerClass: "col-12 col-md-6" },
        { name: "pasaporte", htmlType: "text", dbType: "string", title: t("Pasaporte") ?? "", containerClass: "col-12 col-md-6" },
        { name: "nii", htmlType: "text", dbType: "string", title: t("NII") ?? "", containerClass: "col-12 col-md-6" },
        { name: "codigo", htmlType: "text", dbType: "string", title: t("Código") ?? "", containerClass: "col-12 col-md-6" },
        { name: "cedula", htmlType: "text", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fechaNacimiento", htmlType: "date", dbType: "DateTimeOffset", title: t("Fecha de Nacimiento") ?? "", containerClass: "col-12 col-md-6" },
        { name: "edad", htmlType: "text", dbType: "string", title: t("Edad") ?? "", containerClass: "col-12 col-md-6" },
        { name: "lugarDeNacimiento", htmlType: "text", dbType: "string", title: t("Lugar de Nacimiento") ?? "", containerClass: "col-12 col-md-6" },
        { name: "nacionalidad", htmlType: "text", dbType: "string", title: t("Nacionalidad") ?? "", containerClass: "col-12 col-md-6" },
        { name: "nombrePadre", htmlType: "text", dbType: "string", title: t("Nombre del Padre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "cedulaPadre", htmlType: "text", dbType: "string", title: t("Cédula del Padre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "nombreMadre", htmlType: "text", dbType: "string", title: t("Nombre de la Madre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "cedulaMadre", htmlType: "text", dbType: "string", title: t("Cédula de la Madre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "telefono", htmlType: "text", dbType: "string", title: t("Teléfono") ?? "", containerClass: "col-12 col-md-6" },
        { name: "direccion", htmlType: "text", dbType: "string", title: t("Dirección") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fechaDeDetencion", htmlType: "date", dbType: "DateTimeOffset", title: t("Fecha de Detención") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fichado", htmlType: "text", dbType: "string", title: t("Fichado") ?? "", containerClass: "col-12 col-md-6" },
        { name: "noFicha", htmlType: "text", dbType: "string", title: t("No. Orden Judicial") ?? "", containerClass: "col-12 col-md-6" },
        { name: "noOrdenArresto", htmlType: "text", dbType: "string", title: t("No. Orden de Arresto") ?? "", containerClass: "col-12 col-md-6" },
        { name: "noExpediente", htmlType: "text", dbType: "string", title: t("No. Expediente") ?? "", containerClass: "col-12 col-md-6" },
        { name: "violacion", htmlType: "text", dbType: "string", title: t("Violación") ?? "", containerClass: "col-12 col-md-6" },
        { name: "tribunal", htmlType: "text", dbType: "string", title: t("Tribunal") ?? "", containerClass: "col-12 col-md-6" },
        { name: "fotos", htmlType: "hidden", dbType: "string", title: t("Fotos") ?? "", containerClass: "col-12 col-md-6" },
        { name: "estatusMigratorio", htmlType: "text", dbType: "string", title: t("Estatus Migratorio") ?? "", containerClass: "col-12 col-md-6" },
        { name: "rutaFotos", htmlType: "hidden", dbType: "string", title: t("Ruta Fotos") ?? "", containerClass: "col-12 col-md-6" },
        { name: "idFotos", htmlType: "text", dbType: "string", title: t("ID Fotos") ?? "", containerClass: "col-12 col-md-6" },
        { name: "carpetaFotos", htmlType: "text", dbType: "string", title: t("Carpeta Fotos") ?? "", containerClass: "col-12 col-md-6" },
        { name: "idFotoFrente", htmlType: "pictureExtranjeros", dbType: "string", title: t("ID Foto Frente") ?? "", containerClass: "col-12 col-md-6" },
      ]}
    />
  )
}

export default AdminExtranjerosHaitianosComponent
